module.exports = __webpack_public_path__ + "static/isp_logo_white-d3f9c7d1137605ed2f0837444683c654.png";